import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UmamiService {

  constructor() { }

  loadUmami() {
    const script = document.createElement('script');
    script.src = 'https://umami.demotaller.rogitsolutions.com/script.js';
    script.defer = true;
    script.setAttribute('data-website-id', environment.umamiProjectId);

    document.head.appendChild(script);
  }
}
